import {
	SETMETTINGSTORES
} from './mutation-types.js'

export default {
	[SETMETTINGSTORES](state, stores) {
		state.stores = stores;
	},
}
